import WhIllegalArgumentException from "./WhIllegalArgumentException";

class WhArgumentLt0Exception extends WhIllegalArgumentException {
    constructor(message) {
        super();
        this.message = message;
    }
}

export default WhArgumentLt0Exception


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhArgumentLt0Exception.js